import Icon from '../components/Icon.vue'

Icon.register({
  superscript: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M272 192c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-28l-52.6 75.7 58.6 84.3h22c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-62.4c-5.5 0-10.6-2.8-13.5-7.5l-45.7-72.6c-2.3-3.3-4.4-7-6.2-10.2-1.7 3.3-3.7 7-5.9 10.6l-44.7 72.1c-2.9 4.7-8.1 7.6-13.6 7.6h-64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h26.3l56.6-82.7-52.8-77.3h-30.1c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h68.9c5.5 0 10.7 2.9 13.6 7.6l39.9 65.1c2 3.6 4 7.2 5.7 10.4 1.7-3.2 3.9-6.9 6.2-10.5l40.3-65c2.9-4.7 8.1-7.6 13.6-7.6h67.8zM496 256c8.8 0 16 7.2 16 15.9v32c0 8.8-7.2 16-16 16h-168.1c-8.1 0-14.8-5.9-15.9-13.9-0.8-6.3-1.4-12.6-1.4-19.3 0-103 119.4-123.8 119.4-160 0-11-6.9-23.9-26.3-23.9-12.9 0-23.7 7.8-31.7 18.2-5.1 6.7-14.6 8.3-21.6 3.6l-30.3-20.3c-7.2-4.9-9.3-14.6-4.6-21.9 18-28.4 51.9-50.4 94.4-50.4 47.1 0 97.8 27.5 97.8 88.1 0 24.4-8.4 45.5-25.9 64.6-14.8 16.3-33.7 28.3-50.3 38.9-17.5 11.1-32.8 21.9-36.3 32.4h100.8z'
      }
    ]
  }
})
